/**
 * Where the recommendation on screen stands, read from the server the same way
 * on both phones:
 * - dealt: a position is waiting to be played, the number in colour;
 * - open: Play started it and nobody answered Done yet, the number gray;
 * - checked: played and saved, New comes next, the clock icon gray;
 * - unknown: no position stored for this round yet.
 */
export type RecommendationState = 'dealt' | 'open' | 'checked' | 'unknown';

export interface RecommendationHandshake {
  suggestionRound?: number | null;
  suggestionPositions?: readonly number[] | null;
  positions?: readonly number[];
  openPositions?: readonly number[];
}

export interface CurrentRecommendation {
  state: RecommendationState;
  /** The Chess960 number while it is dealt or open. */
  position: number | null;
}

export function currentRecommendation(handshake: RecommendationHandshake): CurrentRecommendation {
  const drawn = handshake.suggestionPositions?.[handshake.suggestionRound ?? 0];
  if (drawn == null || drawn < 0) return { state: 'unknown', position: null };
  if (handshake.positions?.includes(drawn)) return { state: 'checked', position: null };
  if (handshake.openPositions?.includes(drawn)) return { state: 'open', position: drawn };

  return { state: 'dealt', position: drawn };
}
